@if (hasTariffDetail) {
  <div class="card card-nb h-100">
    <div class="card-body pb-0">
      <div class="row">
        <div class="col-12 h2">
          <app-subscription-title></app-subscription-title>
          <h2>{{ 'telephone_tariff' | i18next }}</h2>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 highlighted">
          @if (isTariffOrdered) {
            <span>{{ 'ordered_tariff_text' | i18next: {
              currentTariff: currentTariffName,
              orderedTariff: orderedTariffName,
              date: orderedTariffDate,
              interpolation: { escapeValue: false }
            } }}</span>
          }
          @if (!isTariffOrdered) {
            <span>{{ 'current_tariff_text' | i18next: {currentTariff: currentTariffName} }}</span>
          }
        </div>
      </div>
      @if (isAdmin) {
        <div class="subinformations">
          <div class="d-flex mt-3 w-100 justify-content-end">
            @if (isTariffOrdered) {
              <button class="btn btn-link small" (click)="cancelTariffOrder()">{{ 'tariff_cancel_order' | i18next }}</button>
            }
            <button [disabled]="isTariffOrdered" class="btn btn-outline-primary" (click)="changeTariff()">{{ 'choose_tariff' | i18next }}</button>
          </div>
        </div>
      }
    </div>
  </div>
}
